import React, { Component, Fragment } from 'react';
import { Draggable } from 'react-beautiful-dnd';
import Modal from 'react-responsive-modal';
import './TaskCardItem.module.scss';
import { connect } from 'react-redux';

/*
*   Import Fontawesome
*/
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

//import components
import Subject from 'components/UI/Subject/Subject';
import TaskView from 'components/UI/Popup/TaskView/TaskView';

const mapStateToProps = (state, props) => {
    return {
        agendaVisibility: state.agenda,
        subjects: state.user_subject.entities,
        homework: state.homework.entities,
        colors: state.color.entities,
        user: state.authentication.user
    };
};

class TaskCardItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showTaskView: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.hideTaskView = this.hideTaskView.bind(this);
        this.showTaskView = this.showTaskView.bind(this);
    }

    handleClick() {

        if (this.props.empty) {
            this.props.showInputMisc();
        }

        if (this.props.task && !this.state.showTaskView) {
            this.showTaskView();
            
        }
    }

    hideTaskView() {
        this.setState({ showTaskView: false });
    }

    showTaskView() {
        this.setState({ showTaskView: true });
    }

    render() {
        const { isPastCard, marked, hasHomework, dark, timer, style, large, task, weekend, extraStyleNames, user }  = this.props;

        let homework = null;
        let subject;
        let isFreeTask = false;
        let overwriteNotDraggable = false;
        let allowMarkingAsFinishedWhenHomeworkHasPassed = false;
        if (!this.props.empty) {

            isFreeTask = task.homework_id == null;
            homework = this.props.homework.byId[task.homework_id];
            subject = homework && this.props.subjects.byId[homework.user_subject_id];
        }

        //Determines description background color based om marked prop
        const isMarked = homework && homework.mark == true;
        
        //Check if card is in the past but homework is in the future, then dragging is allowed
        let homeworkDate = new Date(homework && homework.date);
        homeworkDate.setHours(2);
        homeworkDate.setMinutes(0);
        homeworkDate.setSeconds(0);
        homeworkDate.setMilliseconds(0);
        let today = new Date();
        today.setHours(2);
        today.setMinutes(0);
        today.setSeconds(0);
        today.setMilliseconds(0);

        if (isPastCard) {
            if (isPastCard && task && today <= homeworkDate && (task.status == 'not_started' || task.status == 'finished')) {
                overwriteNotDraggable = true;
            } else if (task && today > homeworkDate && task.status != 'finished') {
                allowMarkingAsFinishedWhenHomeworkHasPassed = true;
            }
        }
        
        return (
            <Fragment>
            
                { this.props.empty ?
                    <div onClick={this.handleClick} style={style} styleName={(timer ? 'timer ':'') + 'carditem-background ' + (weekend ? ' weekendColor ' : '') + (large ? ' large ' : '') + ` ${extraStyleNames ? extraStyleNames : ''}`} >

                    </div>
                    :
                    <Draggable draggableId={this.props.task && this.props.task.id && `task-${this.props.task.id}`} key={this.props.task && this.props.task.id && `task-${this.props.task.id}`}  index={this.props.index} isDragDisabled={this.props.disableDrag || allowMarkingAsFinishedWhenHomeworkHasPassed}>
                        {(provided) => (
                            <div onClick={this.handleClick} styleName={ (timer ? 'timer ':'') + 'carditem-background ' + (large ? 'large ' : '') +(overwriteNotDraggable ? 'overwriteNotDraggable ' : '') + (allowMarkingAsFinishedWhenHomeworkHasPassed ? 'allowMarkingAsFinishedWhenHomeworkHasPassed ' : '') + ` ${extraStyleNames ? extraStyleNames : ''}`} {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                ref={provided.innerRef}
                            >
                                {
                                    !this.props.empty && 
                                <Fragment>
                                    <div styleName="subject-wrapper">
                                        {
                                            isFreeTask ?
                                                task.name == 'plenda_pauze' ?
                                                    <Subject pause color='#f8e764' />
                                                    :
                                                    <Subject misc color='#f8e764' />
                                                :
                                                <Subject abbreviation={subject && subject.subject_abbreviation} color={subject && (homework || isSchedule) && subject.color_id && this.props.colors.allIds.length > 0 && (this.props.agendaVisibility.color ? this.props.colors.byId[subject.color_id].color : '#94bfcf')} />
                                        }
                                        
                                    </div>
                                    <div styleName='content-wrapper'>
                                        {
                                            homework && 
                                        <div styleName='type'>
                                            {homework.type == 'make' && 'M'}
                                            {homework.type == 'learn' && 'L'}
                                            {homework.type == 'make_learn' && 'ML'}
                                            {homework.type == 'read' && 'LZ'}
                                        </div>
                                        }
                                
                                        <div styleName={`description ${(isMarked ? 'marked' : '')}`}>
                                            <p style={{ maxWidth: '65px' }}>{task.name == 'plenda_pauze' ? 'Pauze' : task.name} {(((homework && homework.note) || (homework && homework.image) || (isFreeTask && (task.note || task.image))) && <FontAwesomeIcon icon={[ 'fal','paperclip' ]}/>)}</p>
                                        </div>
                                    </div>
                                    <div styleName="time">
                                        {
                                            user && user.use_timer && this.props.agendaVisibility.time && task.status != 'finished' ?
                                                <p styleName="order">{task.time} min</p>
                                                :
                                                null
                                        }
                                        {(task.status === 'finished' &&
                                            <FontAwesomeIcon style={{ color: '#f8e764', height: '50%' }} icon={[ 'fas','check' ]}/>)
                                        }
                                    </div>

                                </Fragment>
                                } 
                            </div>
                        )}
            
                
                    </Draggable>
                }
                <Modal open={this.state.showTaskView} onClose={this.hideTaskView} center styles={{
                    modal: {
                        background: 'none',
                        boxShadow: 'none'
                    },
                    closeIcon: {
                        fill: '#fff',
                        cursor: 'pointer'
                    }
                }}>
                    <TaskView onClose={this.hideTaskView} onlyAllowMarkingAsFinished={allowMarkingAsFinishedWhenHomeworkHasPassed} task={task}/>
                </Modal>   
            </Fragment>
        );
    }

}

export default connect(mapStateToProps, null)(TaskCardItem);